/**
 * Data layer for `custom-partner-email-sender-domain-smtp-relay-per`. Thin typed fetch wrappers over /api/v1/custom-partner-email-sender-domain-smtp-relay-per.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface CustomPartnerEmailSenderDomainSmtpRelayPerRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListCustomPartnerEmailSenderDomainSmtpRelayPerResponse {
	count: number;
	items: CustomPartnerEmailSenderDomainSmtpRelayPerRow[];
}

export interface CreateCustomPartnerEmailSenderDomainSmtpRelayPerBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/custom-partner-email-sender-domain-smtp-relay-per";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListCustomPartnerEmailSenderDomainSmtpRelayPerResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListCustomPartnerEmailSenderDomainSmtpRelayPerResponse>(res);
}

export async function create(body: CreateCustomPartnerEmailSenderDomainSmtpRelayPerBody): Promise<CustomPartnerEmailSenderDomainSmtpRelayPerRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<CustomPartnerEmailSenderDomainSmtpRelayPerRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const customPartnerEmailSenderDomainSmtpRelayPerQueryKeys = {
	all: ["custom-partner-email-sender-domain-smtp-relay-per"] as const,
	list: () => [...customPartnerEmailSenderDomainSmtpRelayPerQueryKeys.all] as const,
	detail: (id: string) => [...customPartnerEmailSenderDomainSmtpRelayPerQueryKeys.all, id] as const,
};
